import type { ReactNode } from 'react'
import { DocsLink } from '@/components/docs/docs-link'

export interface SectionHeaderProps {
  title: string
  subLabel?: string
  actions?: ReactNode
  guide?: {
    to: string
    hint?: string
    label?: string
  }
}

export function SectionHeader({ title, subLabel, actions, guide }: SectionHeaderProps) {
  return (
    <div className="flex items-start justify-between gap-3 mb-3">
      <div>
        <div className="flex items-center gap-2 mb-0.5">
          <h3 className="text-sm font-semibold text-[var(--foreground)]">{title}</h3>
          {guide && (
            <DocsLink
              to={guide.to}
              label={guide.label ?? 'How it works'}
              hint={guide.hint}
              size="sm"
            />
          )}
        </div>
        {subLabel && <p className="text-xs text-[var(--muted-foreground)]">{subLabel}</p>}
      </div>
      {actions && <div className="shrink-0">{actions}</div>}
    </div>
  )
}
